import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";

export const MonetateContext = createContext({
  liveChatProminenceExperiment: false,
});

export function MonetateProvider({ experiences, liveChatProminenceExperiment, children }) {
  return (
    <MonetateContext.Provider value={{ experiences, liveChatProminenceExperiment }}>
      {children}
    </MonetateContext.Provider>
  );
}

MonetateProvider.propTypes = {
  experiences: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  liveChatProminenceExperiment: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export const findExperience = (experiences, name) =>
  experiences ? experiences.find(item => item.experienceName.includes(name)) : null;

export const useExperience = name => {
  const { experiences } = useContext(MonetateContext);
  return findExperience(experiences, name);
};

export const extractExperiences = (req, devExperiences) => {
  let experiences = process.env.NEXT_PUBLIC_ENVIRONMENT_NAME === "stubs" ? devExperiences : [];
  if (req?.headers["x-experiences-json"]) {
    try {
      experiences = JSON.parse(Buffer.from(req.headers["x-experiences-json"], "base64").toString("utf-8"));
    } catch (err) {
      console.error("Failed parsing x-experiences-json", err);
    }
  }
  return experiences;
};

export const devExperiences = [
  {
    impressionId: null,
    experienceName: "GH | AB-4279 | Streamline JL giftcard hero section",
    variantLabel: "Experiment",
    parameters: { feature: "experiment" },
  },
  {
    impressionId: null,
    experienceName: "AS | AB-5105 | Carrier tracking banner",
    variantLabel: "Experiment",
    parameters: { feature: "experiment" },
  },
  {
    impressionId: null,
    experienceName: "AS | AB-5184 | xmas banner",
    variantLabel: "Experiment",
    parameters: { feature: "experiment" },
  },
  {
    impressionId: "3.MjU0MjQwMi4xLjE3NTIyMzQyMjkuMjM4NjYx",
    experienceId: 2024971,
    experienceName: "RD | AB-5812 | Customer & Account | Returns & Refunds | Agentforce chat button visibility",
    variantLabel: "Experiment",
    parameters: {},
  },
  {
    impressionId: "3.MjU0MjQwjl3j4LGJl3zuwzQyMjkuMjM4NjYx",
    experienceId: 2053271,
    experienceName: "GH | AB-6017 |  AB/ABn Test |  C&A  | Add SS shortcuts to CS page | Mobile and Desktop ",
    variantLabel: "Experiment",
    parameters: {},
  },
];

export const MONETATE_EVENT_NAMES = {
  AB5184ShopGiftCardsClicked: "AB-5184-ShopGiftCardsClicked",
  AB5184FindOutHowClicked: "AB-5184-FindOutHowClicked",
  AB6017ContactRevealed: "AB-6017-failure-contact-reveal",
  AB6017ContactUsDetailsRevealed: "contact_us_details_retrieved",
};

export const trackMonetateEvent = eventKey => {
  if (!eventKey) {
    console.warn("Monetate eventKey is required");
    return;
  }
  window.monetateQ = window.monetateQ || [];
  window.monetateQ.push(["trackEvent", [eventKey]]);
};
